import React from 'react';
import { SkeletonBlock } from './SkeletonBlock';

export const Skeleton = ({ rows, className }) => (
  <div
    className={`tw-w-full tw-flex tw-flex-col tw-gap-5 tw-rounded-lg ${className}`}
  >
    {rows.map(({ cols, height, width = '100%' }, rowIdx) => (
      <div
        key={rowIdx}
        className='tw-flex tw-items-center tw-gap-4 tw-w-full'
        style={{
          width: width,
        }}
      >
        {Array.from({ length: cols })?.map((_, colIdx) => (
          <SkeletonBlock key={colIdx} height={height} />
        ))}
      </div>
    ))}
  </div>
);
